/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlTicket = "/ticket";
// const urlTicketDeleteMultiple = '/master/tickets/delete-multiple'

const state = {
  tickets: [],
  pagination: {
    current_page: 1,
    per_page: 50,
    total: 0,
  },
};

const actions = {
  /**
   * getListTicket
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListTicket({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlTicket}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_TICKETS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * createLevel
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async createTicket({ commit }, payload) {
    return await axios.post(urlTicket, payload);
  },

  /**
   * updateTicket
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async updateTicket({ commit }, { id, payload }) {
    return await axios.put(`${urlTicket}/${id}`, payload);
  },

  /**
   * deleteTicket
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteTicket({ commit }, id) {
    return await axios.delete(`${urlTicket}/${id}`);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_TICKETS(state, data) {
    state.tickets = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
